import '../../css/FormTemplate.css'

const FormEditImg = (props:{id:string, edit:boolean, editClickHandler:(e: any) => void}) => {

    return (
        <img className="form-icon" id={`img ${props.id}`}
        src={props.edit? "/icons/editing.png": "/icons/un-editing.png"}
        alt='edit icon' onClick={props.editClickHandler}
    />
    );
};

export default FormEditImg;